import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Btn from '../../../components/Buttons/Btn';
import NoData from '../../../components/NoData';
import { backendErrorNotification } from '../../../components/Notification';
import HttpStatus from '../../../enums/httpStatus';
import { getFastmanagerUrlsApi } from '../../../services/requests';
import { StoreState } from '../../../store/createStore';
import ContentContainer from '../../../templates/Content/ContentContainer';
import { ApiResponse } from '../../../types';
import { FastmanagerUrls } from '../../../types/apiResponse/integrations';
import { generateRandomToken } from '../../../utils/helpers';

const FastmanagerPageTSX: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state: StoreState) => state.auth);

  const [isLoading, setIsLoading] = useState(false);
  const [fastmanagerUrls, setFastmanagerUrls] = useState<FastmanagerUrls>({});
  const [fastmanagerExternalLoginUrl, setFastmanagerExternalLoginUrl] = useState<string>();

  const getFastmanagerUrls = async () => {
    try {
      setIsLoading(true);

      const response = await getFastmanagerUrlsApi.get();

      if (response.status === HttpStatus.OK) {
        const { data }: ApiResponse<FastmanagerUrls> = response.data;
        setFastmanagerUrls(data);
      }
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFastmanagerUrls();
  }, []);

  useEffect(() => {
    if (
      fastmanagerUrls.fastmanager_url_host &&
      fastmanagerUrls.fastmanager_endpoint_external_login
    ) {
      setFastmanagerExternalLoginUrl(
        // eslint-disable-next-line max-len
        `${fastmanagerUrls.fastmanager_url_host}${fastmanagerUrls.fastmanager_endpoint_external_login}`,
      );
    }
  }, [fastmanagerUrls]);

  const handleOnClick = () => {
    if (user && fastmanagerExternalLoginUrl) {
      // Cria o formulário dinamicamente
      const form = document.createElement('form');
      form.target = '_blank'; // Abre em nova aba
      form.method = 'POST';
      form.action = fastmanagerExternalLoginUrl;
      form.style.display = 'none';

      // Campo de email
      const emailField = document.createElement('input');
      emailField.type = 'hidden';
      emailField.name = 'email';
      emailField.value = user.email;
      form.appendChild(emailField);

      // Campo de token
      const tokenField = document.createElement('input');
      tokenField.type = 'hidden';
      tokenField.name = 'token';
      tokenField.value = generateRandomToken();
      form.appendChild(tokenField);

      // Adiciona o formulário ao body e submete
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  };

  const handleContent = () => {
    if (user && fastmanagerExternalLoginUrl) {
      return <Btn text={t('toAccess')} onClick={handleOnClick} />;
    }

    return <NoData />;
  };

  return (
    <ContentContainer isLoading={isLoading} title={t('fastmanager')}>
      {handleContent()}
    </ContentContainer>
  );
};

export default FastmanagerPageTSX;
